import type { InjectionKey, Ref } from 'vue'

export interface CollapseProvider {
  activeNames: Ref
  handleItemClick: (name: string | number) => void
  lineStyle: boolean | {},
  headerStyle: {}
  contentStyle: {},
  arrowPosition: string
}

export const CollapseContextKey: InjectionKey<CollapseProvider> = Symbol('CollapseContextKey')
